export class AdExtensionChild {
  constructor() {
    this.name = null;
    this.value = null;
    this.attributes = {};
  }
}
